export default "__VITE_ASSET__BT6aR2tX__"